import React, { useState, useRef } from "react";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import "../about/SplashPdfViewer.css";
import CTAButton from "../components/sticky-button";
import PageHeader from "../about/PageHeader";
// import "./Studentdownload.css";
import BrochureForm from "../components/brochure-form";

const MagazineEminence = () => {
  // Reference for scrolling to top of the content
  const topRef = useRef(null);
  const [showForm, setShowForm] = useState(false);

  // Formatted to match the new PDF viewer layout structure
const pdfList = [
    { 
      id: 1, 
      title: "Magazine Eminence 2025-26", 
      src: "/pdf/Life/Colleage Magazine-26.pdf", 
      isWeb: false 
    },
    { 
      id: 2, 
      title: "Magazine Eminence 2024-25", 
      src: "/pdf/Life/Colleage-Magazine-25-InSide-Final.pdf", 
      isWeb: false 
    },
    { 
      id: 3, 
      title: "Magazine Eminence 2023-24", 
      src: "/pdf/Life/Colleage-Magazine-24-InSide-Low-1.pdf", 
      isWeb: false 
    },
    { 
      id: 4, 
      title: "Magazine Eminence 2022-23", 
      src: "/pdf/Life/Colleage-Magazine-23.pdf", 
      isWeb: false 
    },
    { 
      id: 5, 
      title: "Magazine Eminence 2021-22", 
      src: "/pdf/Life/College-Magazine-22-Sample-Copy.pdf", 
      isWeb: false 
    },
    { 
      id: 6, 
      title: "Magazine Eminence 2020-21", 
      src: "/pdf/Life/Colleage-Magazine-21-Final.pdf", 
      isWeb: false 
    },
    { 
      id: 7, 
      title: "Magazine Eminence 2019-20", 
      src: "/pdf/Life/Colleage-Magazine-2020.pdf", 
      isWeb: false 
    },
    { 
      id: 8, 
      title: "Magazine Eminence 2018-19", 
      src: "/pdf/Life/Colleage-Magazine-2019.pdf", 
      isWeb: false 
    },
    { 
      id: 9, 
      title: "Magazine Eminence 2017-18", 
      src: "/pdf/Life/College-Magazine-2018.pdf", 
      isWeb: false 
    },
    { 
      id: 10, 
      title: "Magazine Eminence 2016-17", 
      src: "/pdf/Life/Colleage-Magazine-2016-17-7.pdf", 
      isWeb: false 
    },
  ];
  const [activePdf, setActivePdf] = useState(pdfList[0]);

  const handlePdfSelection = (pdf) => {
    // Scroll the specific element into view smoothly
    if (topRef.current) {
      topRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    // Fallback for window scrolling
    window.scrollTo({ top: 0, behavior: "smooth" });

    if (pdf.isWeb) {
      window.open(pdf.src, "_blank");
    } else {
      setActivePdf(pdf);
    }
  };

  return (
    <>
      <Navbar setShowForm={setShowForm} />
      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButton />

      <div className="spv-modern-portal">
        {/* Attach the ref to the header */}
        <div ref={topRef}>
          <PageHeader 
            title="Magazine Eminence" 
            crumbs={[{ label: 'Home', href: '/' }, { label: 'Magazine Eminence' }]} 
          />
        </div>

        <div className="spv-main-content">
          <aside className="spv-sidebar-modern">
            <div className="spv-sidebar-header-text">MAGAZINE EDITIONS</div>
            <nav className="spv-nav-group">
              {pdfList.map((pdf) => (
                <button
                  key={pdf.id}
                  className={`spv-nav-card ${activePdf.id === pdf.id ? "is-active" : ""}`}
                  onClick={() => handlePdfSelection(pdf)}
                >
                  <div className="spv-card-content">
                    <img 
                      src={pdf.isWeb ? "/images/icons/browser.svg" : "/images/icons/pdf.svg"} 
                      alt="icon" 
                      className="spv-doc-icon-img" 
                    />
                    <span className="spv-card-text">{pdf.title}</span>
                    <img 
                      src="/images/icons/move.webp" 
                      alt="arrow icon" 
                      className="spv-doc-icon-img" 
                    />
                  </div>
                </button>
              ))}
            </nav>
          </aside>

          <main className="spv-viewer-area" key={activePdf.id}>
            <header className="spv-viewer-topbar">
              <div className="spv-info-stack">
                <h2 className="spv-doc-title">{activePdf.title}</h2>
              </div>
              <div className="spv-action-group">
                <button className="spv-btn spv-btn-outline" onClick={() => window.open(activePdf.src, "_blank")}>
                  Full Screen
                </button>
              </div>
            </header>

            <div className="spv-pdf-viewport">
              <div className="spv-pdf-card no-select">
                <iframe
                  src={`${activePdf.src}#toolbar=0&navpanes=0&scrollbar=0`}
                  className="spv-iframe-content secure-frame"
                  title="Magazine Eminence"
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MagazineEminence;